// remove only the class from the target ('data-target' attribute) of an array of elements
// remove only the targetClass from an array of elements
function removeClassFromElements(elementsArray, targetClass) {
    if (!Array.isArray(elementsArray)) {
        console.log('Error: removeClassFromElements requires an array elements.');
        return;
    };

    elementsArray.forEach(element => element.classList.remove(targetClass));
}

function removeClassFromTargetElements(elementsArray, className) {
    elementsArray.forEach(element => getTargetElement(element).classList.remove(className));
}

function setTemporaryClass(element, className, delay) {
    element.classList.add(className);
                
    setTimeout(() => {
        element.classList.remove(className);

    }, delay);
}

// get the target ('data-target' attribute) of an elements
function getTargetElement(element) {
    const targetID = element.dataset.target;
    return document.getElementById(targetID);
}

function removeElement(element) {
    element.parentNode.removeChild(element);
}

function createOverlay(element, overlayClass) { 
    const overlayElement = document.createElement('div');    
    overlayClass = overlayClass || 'page__overlay';

    overlayElement.classList.add(overlayClass);
    element.insertAdjacentElement('beforebegin', overlayElement);
    
    return overlayElement;
}

function isVisible(element) {
    return element =>
        element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length;
}

const random = (min, max) => Math.floor(Math.random() * (max - min)) + min;

function formatDollars(value, includeSymbol = true, includeCents) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const parts = formatter.formatToParts(value);
    const formattedInteger = parts
        .map((part) => {
            return part.type === 'integer' || part.type === 'group'
                ? part.value
                : '';
        })
        .join('');

    const symbol = includeSymbol ? parts[0].value : '';
    const cents = includeCents ? `. ${parts[parts.length - 1]}` : '';

    return `${symbol}${formattedInteger}${cents}`;
}

const numberToStringShorthand = (value) => {
    if (value === 0) return value;

    // shorthand label
    const labels = ['', 'k', 'm', 'b', 't'];

    // dividing the value by 3.
    var sNum = ('' + value).length / 3;

    if (sNum % 2 === 0) return ('' + value).slice(0, 3) + labels[1];
    if (sNum < 2) return ('' + value).slice(0, 2) + labels[1];

    sNum = Math.floor(sNum);
    // calculating the precised value.

    var sVal = parseFloat(
        (sNum != 0 ? value / Math.pow(1000, sNum) : value).toPrecision(2),
    );

    sVal = sVal.toFixed(1);

    // appending the letter to precised val.
    return sVal + labels[sNum];
};

const capitalizeWord = (word) => {
    return word[0].toUpperCase() + word.slice(1);
};

export {
	removeClassFromElements,
	removeClassFromTargetElements,
	setTemporaryClass,
	getTargetElement,
	removeElement,
	createOverlay,
	isVisible,
	random,
	formatDollars,
	numberToStringShorthand,
	capitalizeWord
};
